import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TERMS_CONTENT } from './termsContent';

export default function TermsOfUsePage() {
  useEffect(() => {
    document.title = 'Terms of Use — CerebralMachines Denial Management';
  }, []);

  const { intro = [], sections = [] } = TERMS_CONTENT || {};

  return (
    <div className="terms-page">
      <header className="terms-header">
        <Link to="/login" className="terms-brand">
          <span className="terms-brand__cm">CerebralMachines</span>
          <span className="terms-brand__dm">Denial Management</span>
        </Link>
        <Link to="/login" className="terms-back">← Back to sign in</Link>
      </header>

      <article className="terms-article">
        <h1 className="terms-title">Terms of Use</h1>

        {intro.map((p, i) => (
          <p key={`intro-${i}`} className="terms-para">{p}</p>
        ))}

        {sections.map((s) => (
          <section key={s.id} className="terms-section">
            <h2 className="terms-section__title">{s.title}</h2>
            {(s.paragraphs || []).map((p, i) => (
              <p key={`${s.id}-${i}`} className="terms-para">{p}</p>
            ))}
          </section>
        ))}
      </article>

      <footer className="terms-footer">
        <span>© {new Date().getFullYear()} CerebralMachines, Inc. All rights reserved.</span>
      </footer>
    </div>
  );
}
